import { Pencil, Trash2 } from "lucide-react";
import { useState } from "react";

export default function RulesTable({ rules, onEdit, onDelete }) {
  const [hoveredRule, setHoveredRule] = useState(null);

  return (
    <div className="space-y-2">
      {/* Rules List */}
      <div className="space-y-1.5">
        {rules.map((r) => (
          <div
            key={r.id}
            onMouseEnter={() => setHoveredRule(r.id)}
            onMouseLeave={() => setHoveredRule(null)}
            className="group flex flex-col bg-white hover:bg-gray-50/50 border border-gray-100 rounded-md transition-colors"
          >
            {/* Rule Text */}
            <div className="px-3 py-2 text-xs font-medium text-gray-700">
              {r.label}
            </div>

            {/* Score and Actions Row */}
            <div className="flex items-center justify-between px-3 py-1.5 border-t border-gray-100/60 bg-gray-50/40">
              {/* Score */}
              <div>
                <span className={`inline-flex items-center px-2 py-0.5 bg-blue-50 text-blue-600 rounded-full text-[11px] font-medium transition-all
                  ${hoveredRule === r.id ? 'bg-blue-100 text-blue-700' : ''}`}>
                  Score: {r.score}
                </span>
              </div>

              {/* Actions */}
              <div className="flex gap-1">
                <button
                  onClick={() => onEdit(r)}
                  className={`p-1 text-gray-400 rounded-full transition-all
                    ${hoveredRule === r.id ? 'text-blue-500 bg-blue-50' : 'hover:text-blue-500 hover:bg-blue-50'}`}
                  title="Edit Rule"
                >
                  <Pencil size={13} />
                </button>
                <button
                  onClick={() => onDelete(r.id)}
                  className={`p-1 text-gray-400 rounded-full transition-all
                    ${hoveredRule === r.id ? 'text-red-500 bg-red-50' : 'hover:text-red-500 hover:bg-red-50'}`}
                  title="Delete Rule"
                >
                  <Trash2 size={13} />
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}